import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.8 6.22222H12.8L8 11.5556L3.2 6.22222H7.2V0H8.8V6.22222ZM1.6 14.2222H14.4V8H16V15.1111C16 15.602 15.6418 16 15.2 16H0.8C0.358176 16 0 15.602 0 15.1111V8H1.6V14.2222Z"
      fill="#090909"
    />
  </svg>
);

export default Icon;
